jQuery(document).ready(function ($) {
  // Make images responsive
  $("img[class*='wp-image-']").addClass("img-responsive");
  $("figure[class*='wp-caption']").addClass("img-responsive");

  // Make tables dynamic
  var $pubtable = $("#publicationtable").stupidtable();
  var $pub_th_to_sort = $pubtable.find("thead th").eq(0);
  $pub_th_to_sort.stupidsort("desc");
  // Make tables dynamic
  var $projtable = $("#projecttable").stupidtable();
  var $proj_th_to_sort = $projtable.find("thead th").eq(0);
  $proj_th_to_sort.stupidsort("desc");

  // Hide overlay when little content is present
  var $content_body = $("#overlay-row");
  if ($content_body.height() < 600) {
    $("#default-overlay").css("display", "none");
  }
  if ($content_body.height() < 1600) {
    $("#default-second-overlay").css("display", "none");
  }

  // Add hover effect to pagination
  $(".pagination").not(".disabled").children().addClass("hvr-grow");

  // Toogle Search bar
  var $searchbar = $("#searchbar");
  $(".nav-search").click(function () {
    if ($searchbar.css("display") == "none") {
      $searchbar.css("display", "block");
    } else {
      $searchbar.css("display", "none");
    }
  });

  // Show search bar when anchor present
  var url = document.location.toString();
  if (url.split("#")[1] == "search") {
    $searchbar.css("display", "block");  
  }

  $(".owl-carousel").owlCarousel({
    loop: true,
    stagePadding: 4,
    margin: 10,
    nav: true,
    autoHeight: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  });
});
